import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bitbucket': {
    width: 499,
    height: 512,
    paths: [
      {
        d: 'M16.2 31.6C7.4 31.5 0.1 38.5 0 47.4 0 48.3 0.1 49.3 0.2 50.2L68.1 462.3C69.8 472.7 78.8 480.4 89.4 480.5H415.1C423 480.6 429.8 474.9 431.1 467.1L499 50.3C500.4 41.6 494.5 33.4 485.8 32 484.9 31.9 484 31.8 483 31.8L16.2 31.6zM302.1 329.4H198.1L170 182.4H327.3L302.1 329.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bitbucket.js
// module id = se1m
// module chunks = 144